import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AuthContext } from '../contexts/AuthContext';
import { Snackbar } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import VideocamIcon from '@mui/icons-material/Videocam';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import SecurityIcon from '@mui/icons-material/Security';
import { useNavigate } from 'react-router-dom';

const defaultTheme = createTheme();

export default function Authentication() {

    const navigate = useNavigate();

    const [username, setUsername] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [name, setName] = React.useState("");
    const [error, setError] = React.useState("");
    const [message, setMessage] = React.useState("");

    const [formState, setFormState] = React.useState(0);

    const [open, setOpen] = React.useState(false)

    const { handleRegister, handleLogin } = React.useContext(AuthContext);

    let handleAuth = async () => {
        try {
            if (formState === 0) {
                let result = await handleLogin(username, password)
            }
            if (formState === 1) {
                let result = await handleRegister(name, username, password);
                console.log(result);
                setUsername("");
                setMessage(result);
                setOpen(true);
                setError("")
                setFormState(0)
                setPassword("")
            }
        } catch (err) {
            console.log(err);
            let message = (err.response.data.message);
            setError(message);
        }
    }

    return (
        <ThemeProvider theme={defaultTheme}>
            <div className="auth-page">
                <CssBaseline />
                
                <button className="auth-back-btn" onClick={() => navigate('/')}>
                    <ArrowBackIcon />
                    <span>Back to Home</span>
                </button>

                <div className="auth-container">
                    <div className="auth-left">
                        <div className="auth-visual-content">
                            <div className="auth-floating-avatar auth-avatar-1">
                                <PersonIcon />
                            </div>
                            <div className="auth-floating-avatar auth-avatar-2">
                                <GroupIcon />
                            </div>
                            <div className="auth-floating-avatar auth-avatar-3">
                                <VideocamIcon />
                            </div>
                            <div className="auth-floating-avatar auth-avatar-4">
                                <SecurityIcon />
                            </div>
                            <div className="auth-center-avatar">
                                <VideocamIcon className="auth-center-icon" />
                            </div>
                            <div className="auth-connection-line line-1"></div>
                            <div className="auth-connection-line line-2"></div>
                            <div className="auth-connection-line line-3"></div>
                            <div className="auth-connection-line line-4"></div>
                        </div>
                    </div>

                    <div className="auth-right">
                        <div className="auth-form-container">
                            <div className="auth-form-header">
                                <Avatar className="auth-avatar">
                                    <LockOutlinedIcon />
                                </Avatar>
                                <h2 className="auth-form-title">Welcome</h2>
                                <p className="auth-form-subtitle">
                                    {formState === 0 ? 'Sign in to your account' : 'Create your account'}
                                </p>
                            </div>

                            <div className="auth-toggle-buttons">
                                <button 
                                    className={`auth-toggle-btn ${formState === 0 ? 'active' : ''}`}
                                    onClick={() => { setFormState(0); setError(""); }}
                                >
                                    Sign In
                                </button>
                                <button 
                                    className={`auth-toggle-btn ${formState === 1 ? 'active' : ''}`}
                                    onClick={() => { setFormState(1); setError(""); }}
                                >
                                    Sign Up
                                </button>
                            </div>

                            <Box component="form" noValidate className="auth-form">
                                {formState === 1 ? (
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="name"
                                        label="Full Name"
                                        name="name"
                                        value={name}
                                        autoFocus
                                        onChange={(e) => setName(e.target.value)}
                                        className="auth-input"
                                    />
                                ) : null}

                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="username"
                                    label="Username"
                                    name="username"
                                    value={username}
                                    autoFocus={formState === 0}
                                    onChange={(e) => setUsername(e.target.value)}
                                    className="auth-input"
                                />
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    value={password}
                                    type="password"
                                    onChange={(e) => setPassword(e.target.value)}
                                    id="password"
                                    className="auth-input"
                                />

                                {error && <p className="auth-error">{error}</p>}

                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    className="auth-submit-btn"
                                    onClick={handleAuth}
                                >
                                    {formState === 0 ? "Sign In" : "Create Account"}
                                </Button>
                            </Box>
                        </div>
                    </div>
                </div>
            </div>

            <Snackbar
                open={open}
                autoHideDuration={4000}
                message={message}
                onClose={() => setOpen(false)}
            />
        </ThemeProvider>
    );
}